import { _t } from '@/i18n/t';

import { useScanRunDate } from '../hooks/useScanRunDate';

function hostOf(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
}

/**
 * The terminal beat. The scan does not finish on a seventh stage of its own —
 * it finishes by naming the document it just produced, which is the same
 * masthead the reveal opens with, down to the run date.
 */
export default function ScanReportCard({ url }: { url: string }) {
  const { runDate } = useScanRunDate();

  return (
    <div className="ob-report" data-testid="onboarding-scan-report">
      <div className="ob-report__masthead">
        <h2 className="ob-report__name text-foreground">{_t('onboarding.crawl.report.name')}</h2>
        <span className="ob-report__meta text-muted-foreground">
          {hostOf(url)}
          {runDate && <span data-testid="onboarding-scan-report-date">{` \u00B7 ${runDate}`}</span>}
        </span>
      </div>
      <h1 className="ob-report__head text-foreground">{_t('onboarding.crawl.compileHead')}</h1>
    </div>
  );
}
